export default __webpack_public_path__ + "static/media/user_checked.68266ab8.svg";